import React, { useEffect, useMemo, useState } from 'react';
import CompanyTitle from '../CompanyTitle';
import { MaterialInput } from '../MaterialUi';
import SocialMediaIcons from './../miniButtons/SocialMediaIcons';
import SendIcon from '@mui/icons-material/Send';
import { useSelector, useDispatch } from 'react-redux';
import { getContacts } from '../../actions';
import { Link } from 'react-router-dom';

const FooterComponent = () => {
    const [email, setEmail] = useState("");

    const contactState = useSelector((state) => state.contact.contact);
    const { authenticate, user } = useSelector((state) => state.auth);

    const dispatch = useDispatch();

    const contacts = useMemo(() => {
        if (Array.isArray(contactState)) {
            return contactState;
        }

        if (contactState && typeof contactState === "object") {
            return [contactState];
        }

        return [];
    }, [contactState]);

    useEffect(() => {
        if (authenticate && user?.email) {
            setEmail(user.email);
            return;
        }

        setEmail("");
    }, [authenticate, user?.email]);

    useEffect(() => {
        dispatch(getContacts());
    }, [dispatch]);

    const footerYear = new Date().getFullYear();

    const mainContact = contacts[0];

    return (
        <footer className="footer">
            <div className="footer__inner">
                <section className="footer__top">
                    <div className="footer__brand">
                        <CompanyTitle />

                        <p>
                            Производство памятников, металлических оград, МАФов,
                            3D-дизайн и цифровая сборка сцен.
                        </p>

                        <div className="footer__socials">
                            <SocialMediaIcons />
                        </div>
                    </div>

                    <nav className="footer__nav" aria-label="Нижнее меню сайта">
                        <h3>Навигация</h3>

                        <div className="footer__navGrid">
                            <Link to="/maf">Главная</Link>
                            <Link to="/about">О нас</Link>
                            <Link to="/productsCategory/all">Каталог</Link>
                            <Link to="/contacts">Контакты</Link>
                        </div>
                    </nav>

                    <div className="footer__contacts">
                        <h3>Контакты</h3>

                        {mainContact ? (
                            <div className="footer__contactCard">
                                <span>
                                    {[mainContact.cityIndex, mainContact.city, mainContact.country].filter(Boolean).join(" ")}
                                </span>

                                {mainContact.number && (
                                    <a href={`tel:${String(mainContact.number).replace(/\s/g, "")}`}>
                                        {mainContact.number}
                                    </a>
                                )}
                            </div>
                        ) : (
                            <div className="footer__contactCard">
                                <span>Контакты загружаются</span>
                            </div>
                        )}
                    </div>

                    <div className="footer__subscribe">
                        <h3>Рассылка</h3>

                        <p>
                            Новости платформы, новые изделия и обновления каталога.
                        </p>

                        <div className="footer__subscribeForm">
                            <MaterialInput
                                type="text"
                                label="Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />

                            <Link
                                className="footer__subscribeButton"
                                to="/emailNewsletter"
                                aria-label="Перейти к настройкам рассылки"
                            >
                                <SendIcon />
                            </Link>
                        </div>
                    </div>
                </section>

                <section className="footer__bottom">
                    <p>© {footerYear} ALOTB. Все права защищены.</p>

                    <div className="footer__bottomLinks">
                        <Link to="/contacts">Контакты</Link>
                        <Link to="/productsCategory/all">Каталог</Link>
                    </div>
                </section>
            </div>
        </footer>
    );
};

export default FooterComponent;